import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useUser } from "../Contexts/UserContext";
import CustomDatePicker from "./CustomDatePicker";

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const ReportSelector2 = ({ handleShowReports }) => {
  const [selectedData, setSelectedData] = useState({
    branchObj: { BranchCode: "all", BranchName: "All" },
    unitObj: { UnitCode: "all", UnitName: "All" },
    empObj: { EmpCode: "all", EmpName: "All" },
  });

  const [fromDate, setFromDate] = useState(undefined);
  const [toDate, setToDate] = useState(undefined);

  const [list, setList] = useState({
    branchList: [{ BranchCode: "all", BranchName: "All" }],
    unitList: [{ UnitCode: "all", UnitName: "All" }],
    empList: [{ EmpCode: "all", EmpName: "All" }],
  });

  const { user } = useUser();
  const { ClientId, CompCode } = user;

  useEffect(() => {
    const fetchInitData = async () => {
      const res = await fetch(
        `${API_URL}/facility/get-client-all-unit/1/${ClientId}/0`
      ).then((res) => res.json());
      const response = await fetch(
        `${API_URL}/facility/get-facility-emp-list/1/${CompCode}/${ClientId}/UNTPFS00008510`
      ).then((res) => res.json());
      if (response.success) {
        setList((prev) => ({
          ...prev,
          empList: [{ EmpCode: "all", EmpName: "All" }, ...response.data],
        }));
      } else {
        alert("ERROR");
      }
      if (!res.success) {
        alert(res.message);
        return;
      }

      setList((prev) => ({
        ...prev,
        branchList: [
          { BranchCode: "all", BranchName: "All" },
          ...res.data.branches,
        ],
        unitList: [{ UnitCode: "all", UnitName: "All" }, ...res.data.units],
      }));
    };
    fetchInitData();
  }, []);

  const handleUnit = async (value) => {
    const res = await fetch(
      `${API_URL}/facility/get-client-all-unit/2/${ClientId}/${value.BranchCode}`
    ).then((res) => res.json());
    console.log(res);
    if (!res.success) {
      alert(res.message);
      return;
    }
    setList((prev) => ({
      ...prev,
      unitList: [{ UnitCode: "all", UnitName: "All" }, ...res.data.units[0]],
    }));
  };

  const OnDataSelect = (key, value) => {
    if (value === null) return;
    if (key === "branchObj") {
      setSelectedData((prev) => ({
        ...prev,
        unitObj: { UnitCode: "all", UnitName: "All" },
      }));
      handleUnit(value);
    }
    setSelectedData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={{
          p: 1.5,
          mb: 2,
          bgcolor: "background.default",
          boxShadow: 3,
          borderRadius: 2,
          border: "2px solid #D10101",
        }}
      >
        <Stack
          width="100%"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Autocomplete
            size="small"
            options={list.branchList || []}
            getOptionLabel={(option) => option.BranchName}
            isOptionEqualToValue={(option, value) =>
              option.BranchCode === value.BranchCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Branch" size="small" />
            )}
            value={selectedData.branchObj}
            onChange={(e, value) => {
              OnDataSelect("branchObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          {console.log("EmpList", list.empList)}
          <Autocomplete
            size="small"
            options={list.unitList || []}
            getOptionLabel={(option) => option.UnitName}
            isOptionEqualToValue={(option, value) =>
              option.UnitCode === value.UnitCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Unit" size="small" />
            )}
            value={selectedData.unitObj}
            onChange={(e, value) => {
              OnDataSelect("unitObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          <Autocomplete
            size="small"
            options={list.empList || []}
            getOptionLabel={(option) => option.EmpName}
            isOptionEqualToValue={(option, value) =>
              option.EmpCode === value.EmpCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Employee" size="small" />
            )}
            value={selectedData.empObj}
            onChange={(e, value) => {
              OnDataSelect("empObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() =>
              handleShowReports(
                selectedData.branchObj,
                selectedData.unitObj,
                selectedData.empObj
              )
            }
            disabled={!selectedData.unitObj}
            sx={{
              fontSize: "12px",
            }}
          >
            Show
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ReportSelector2;
